<script setup lang="ts">
/**
 * AppHeader — Thin shell that renders the main navigation bar.
 *
 * INC-007 refactor: the nav logic moved to AppNav.vue. This component
 * exists to keep the App.vue template stable and provide a mounting point
 * for the nav. Brand name APP_NAME flows through AppNav from src/data/app.ts.
 */
import AppNav from '@/components/AppNav.vue'
</script>

<template>
  <header class="sticky top-0 z-30 border-b border-border bg-background/90 backdrop-blur-sm">
    <div class="mx-auto max-w-5xl px-6 py-3">
      <AppNav />
    </div>
  </header>
</template>
